(function () {
  "use strict";

  function initPriceRangeSliders() {
    const filterRanges = document.querySelectorAll("[data-filter-group-range]");

    filterRanges.forEach(function (filterRange) {
      if (filterRange.hasAttribute("data-range-initialized")) return;

      filterRange.setAttribute("data-range-initialized", "true");

      const minSlider = filterRange.querySelector(
        ".collection-filters__range-slider--min"
      );
      const maxSlider = filterRange.querySelector(
        ".collection-filters__range-slider--max"
      );
      const minInput = filterRange.querySelector("[data-range-input-min]");
      const maxInput = filterRange.querySelector("[data-range-input-max]");
      const progress = filterRange.querySelector(
        ".collection-filters__range-slider-progress"
      );
      const form = filterRange.closest("form");

      if (!minSlider || !maxSlider || !minInput || !maxInput || !progress)
        return;

      const maxValue = parseFloat(maxSlider.max);

      function updateProgress() {
        const minVal = parseFloat(minSlider.value);
        const maxVal = parseFloat(maxSlider.value);
        const minPercent = (minVal / maxValue) * 100;
        const maxPercent = (maxVal / maxValue) * 100;

        progress.style.left = minPercent + "%";
        progress.style.width = maxPercent - minPercent + "%";
      }

      function syncSliders() {
        const minVal = parseFloat(minSlider.value);
        const maxVal = parseFloat(maxSlider.value);

        if (minVal > maxVal) {
          minSlider.value = maxVal;
          maxSlider.value = minVal;
        }

        const oldMinValue = minInput.value;
        const oldMaxValue = maxInput.value;

        minInput.value = minSlider.value;
        maxInput.value = maxSlider.value;

        ["change", "input"].forEach(function (eventType) {
          const event = new Event(eventType, {
            bubbles: true,
            cancelable: true,
          });
          minInput.dispatchEvent(event);
          maxInput.dispatchEvent(event);
        });

        if (form) {
          const formChangeEvent = new Event("change", {
            bubbles: true,
            cancelable: true,
          });
          form.dispatchEvent(formChangeEvent);
        }

        updateProgress();
      }

      function syncInputs() {
        const minVal = parseFloat(minInput.value) || 0;
        const maxVal = parseFloat(maxInput.value) || maxValue;

        if (minVal < 0) minInput.value = 0;
        if (maxVal > maxValue) maxInput.value = maxValue;

        minSlider.value = minInput.value || 0;
        maxSlider.value = maxInput.value || maxValue;
        updateProgress();
      }

      minSlider.addEventListener("input", syncSliders);
      maxSlider.addEventListener("input", syncSliders);
      minInput.addEventListener("input", syncInputs);
      maxInput.addEventListener("change", syncInputs);

      updateProgress();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPriceRangeSliders);
  } else {
    initPriceRangeSliders();
  }
  document.addEventListener("shopify:section:load", initPriceRangeSliders);
  document.addEventListener("shopify:section:reorder", initPriceRangeSliders);
})();
